import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import logo from "../../assets/img/logo_menu_black.png";

class CartaEgreso extends Component {
    state = {  }
    
    render() {
        const styles = StyleSheet.create(CONSTANCIA[0]);

        let DatPersonales = this.props.datos.datosPersonales;
        let nombre2 = "";
        let apellido2 = "";
        (DatPersonales.nombre_2 === null) ? nombre2 = "" : nombre2 = DatPersonales.nombre_2;
        (DatPersonales.apellido_2 === null) ? apellido2 = "" : apellido2 = DatPersonales.apellido_2;
        let Estudiante = `${DatPersonales.nombre_1} ${nombre2} ${DatPersonales.apellido_1} ${apellido2}`;
        let Cedula = `${DatPersonales.nacionalidad} ${DatPersonales.ci}`;

        let fecha = () => {
            let fehaEnt = this.props.fecha;
            let fechaPartes = fehaEnt.split("/")
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            return `${fechaPartes[0]} días del mes de ${meses[parseInt(fechaPartes[1]) - 1]} de ${fechaPartes[2]}`
        }

        return (
            <PDFViewer style={styles.section}>
                <Document title="Carta de Egreso">
                    <Page size="letter" style={styles.body}>
                        <View>
                            <Image style={[styles.logo, {marginBottom: 30}]} src={logo} />
                            <Text style={styles.encabezado2}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={styles.encabezado5}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>

                            <Text style={[styles.encabezado2, {marginTop: 20}]}>CONSTANCIA DE TRAMITACION DE TÍTULO</Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 20}]}>
                                Quien suscribe, Dra {this.props.datos.nameDir}, titular de la Cédula de Identidad V-{this.props.datos.cedulaDir}, en su carácter de Directora del Instituto Universitario De Diseño Las Mercedes,   hace constar  que el (la) ciudadano (a):
                            </Text>

                            <Text style={[styles.nombre, {marginTop: 10, marginBottom: 10}]}>
                                {Estudiante}
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Titular de la Cédula de Identidad {Cedula}, luego de haber culminado la totalidad de la carga académica de la Carrera {this.props.datos.carrera}, actualmente se encuentra en trámites administrativos correspondientes a la conformación del Expediente de Egreso, según lo establecido en la normativa vigente de esta casa de estudios, a los fines de ser incluido en el Acto de Grado previsto en el cronograma establecido por la institución.
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Constancia que se expide a solicitud de la parte interesada, en Caracas, a los {fecha()}.
                            </Text>

                            <Text style={[styles.firma, {marginTop: 60}]}> {this.props.datos.nameDir}</Text>
                            <Text style={[styles.firma, {marginTop: -5}]}> Directora </Text>

                            <View style={[styles.footer3]}>
                                <View style={[styles.row]}>
                                    <View style={[styles.col11]}>
                                        <Text style={[styles.linea3]}></Text>
                                        <Text style={[styles.encabezado, {fontSize: 7}]}>
                                            Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                            C.P.1061  Edo Miranda - Caracas - Venezuela
                                        </Text>
                                        <Text style={[styles.encabezado, {marginTop: -5, fontSize: 7}]}>
                                            Telefax: +58 212 9930983 | 9939139 | 9910710.
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        )
    }
}

export default CartaEgreso;


// WEBPACK FOOTER //
// ./src/components/Reportes/CartaEgreso.jsx